import React from "react";
import { ChatLogContext, type ChatLog } from "./chat-log-context";
import { initializeChat, clearSessionId } from "../../libs/fns";
import { useChatbotConfig } from "../chatbot-config";
import { useIdleReset } from "./use-idle-reset";

export function ChatLogProvider({ children }: { children: React.ReactNode }) {
  const [chatLogs, setChatLogs] = React.useState<ChatLog[]>([]);
  const { setChatbotConfig } = useChatbotConfig();
  const isInitializedRef = React.useRef<boolean>(false);

  async function init() {
    try {
      const { message, fullResponse } = await initializeChat(window.location.href);
      if (fullResponse) {
        setChatbotConfig(fullResponse);
      } else {
        console.warn("No configuration data received from initialize API");
      }
      setChatLogs([{ type: "AI", message }]);
      isInitializedRef.current = true;
    } catch (error) {
      console.error("[ChatLogProvider] 初期化API失敗:", error);
      setChatLogs([
        {
          type: "AI",
          message: {
            model: "申し訳ありません、チャットを初期化できませんでした。",
            answer: [],
            url: [],
            asset_data: [],
          },
        },
      ]);
      isInitializedRef.current = true;
    }
  }

  const handleIdleReset = React.useCallback(async () => {
    clearSessionId();
    setChatLogs([]);
    await init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { resetIdleTimer, clearIdleTimer } = useIdleReset(handleIdleReset);

  React.useEffect(() => {
    if (isInitializedRef.current) return;
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    return () => clearIdleTimer();
  }, [clearIdleTimer]);

  return (
    <ChatLogContext.Provider value={{ chatLogs, setChatLogs, resetIdleTimer }}>
      {children}
    </ChatLogContext.Provider>
  );
}
